import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import SkillsTabPanel from "./SkillsTabPanel";
const SkillsTabPanelPreview = () => {
    return (_jsx(SkillsTabPanel, { title: "Comp\u00E9tences", text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, nunc ut aliquam lacinia, nunc nisl aliquam nisl, eget aliquam nunc nisl eget nunc.", dynamicList: [
            {
                title: "React",
                image: _jsx("img", { src: "/path/to/react-logo.png", alt: "React" }),
            },
            {
                title: "TypeScript",
                image: _jsx("img", { src: "/path/to/typescript-logo.png", alt: "TypeScript" }),
            },
        ] }));
};
export default SkillsTabPanelPreview;
